import { render, staticRenderFns } from "./OtherType.vue?vue&type=template&id=2b84fa0a&scoped=true&"
import script from "./OtherType.vue?vue&type=script&lang=js&"
export * from "./OtherType.vue?vue&type=script&lang=js&"
import style0 from "./OtherType.vue?vue&type=style&index=0&id=2b84fa0a&prod&lang=stylus&scoped=true&"
import style1 from "./OtherType.vue?vue&type=style&index=1&id=2b84fa0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84fa0a",
  null
  
)

export default component.exports